

* {
	box-sizing:border-box;
}

:host {

	/**
	* @prop --modal-close-button-color: color of close icon. Default rgb(136, 125, 117)
	* @prop --backdrop-color: color of backdrop. Default value rgba(232, 228, 225, .5)
	* @prop --background-color: background of modal. Default value white
	* @prop --scrollbar-color: scrollbar color. Default rgb(0,61,105)
	* @prop --scrollbar-thumb-color: scrollbar thumb color. Default rgb(136,125,117) (adesso-blue-4)
	* @prop --align-modal: position of modal. Default safe center
	* @prop --modal-padding: padding of modal. Default 2rem
	*/

	--modal-close-button-color: rgb(136, 125, 117);
	--backdrop-color: rgba(232, 228, 225, .5);
	--background-color: white;
	--scrollbar-color: rgb(0,61,105);
	--scrollbar-thumb-color: rgb(136,125,117);
	--align-modal: safe center;
	--modal-padding: 2rem;

	display:inline-block;
}

:host(.top) {
	--align-modal: safe top;
}

:host(.transparent) {
	--background-color: transparent;
	--modal-padding:0;
}

::backdrop {
	backdrop-filter: blur(5px);
	background-color:var(--backdrop-color);
}

.slide-in-blurred-top {
	animation: slide-in-blurred-top 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
}

@-webkit-keyframes slide-in-blurred-top {
	0% {
		transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
		transform-origin: 50% 0%;
		filter: blur(40px);
		opacity: 0;
	}
	100% {
		transform: translateY(0) scaleY(1) scaleX(1);
		transform-origin: 50% 50%;
		filter: blur(0);
		opacity: 1;
	}
}
@keyframes slide-in-blurred-top {
	0% {
		transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
		transform-origin: 50% 0%;
		filter: blur(40px);
		opacity: 0;
	}
	100% {
		transform: translateY(0) scaleY(1) scaleX(1);
		transform-origin: 50% 50%;
		filter: blur(0);
		opacity: 1;
	}
}


.popup {
	min-height: 170px;
	padding:1rem;
	align-self: var(--align-modal);
	border:none;
	background:none;
	margin:0 auto;
	overflow:hidden;
	overscroll-behavior: contain;
	max-height:none;
}

slot[name="modal"] {
	display: flex;
	flex-direction: column;
	background-color: var(--background-color);
	padding:var(--modal-padding);
	filter: drop-shadow(0 5px 15px rgba(0, 0, 0, .5));
	max-height:calc(90vh);
	overflow-y:auto;
	overscroll-behavior: contain;
	overflow-x:hidden;
	width:100%;
}

slot[name="modal"].white {
	background-color: white;
}

slot[name="modal"].transparent {
	padding:0;
	background-color:transparent;
}


.modal--content {
	padding:2rem .5rem;
	max-width:100%;
	width:100vw;
}

slot[name="button"] {
	cursor:pointer;
}

slot[name="button"]:focus {
	outline: solid black 2px;
}

* {
	scrollbar-width: auto;
	scrollbar-color: var(--scrollbar-color) transparent;
}

*::-webkit-scrollbar {
	width: 16px;
}

*::-webkit-scrollbar-track {
	background: transparent;
}

*::-webkit-scrollbar-thumb {
	background-color: var(--scrollbar-thumb-color);
	border-radius: 10px;
	border: 3px solid var( --scrollbar-thumb-color);
}

.white::-webkit-scrollbar-thumb {
	border: 3px solid white;
}

.close-btn {
	background-color: transparent;
	border-width: 0;
	font-family: inherit;
	font-size: 1.75rem;
	color: var(--modal-close-button-color);
	font-style: inherit;
	font-weight: inherit;
	line-height: inherit;
	padding:0;
	cursor: pointer;
	display:block;
	position:absolute;
	right:2rem;
	top:0;
	filter: drop-shadow(0 5px 15px var(--backdrop-color));
}

.close-btn {
	transition: all 0.2s linear;
}

.close-btn:hover {
	transform:rotate(90deg);
}

.close-btn:focus {
	outline: none;
}

@media screen and (min-width:1024px) {
	.popup {
		max-width: 90%;
	}

	.modal--content {
		width:75vw;
	}

	.close-btn {
		right:0;
	}
}